import { API, getAsyncThunk } from 'app/api';

export const login = getAsyncThunk(
  'AUTH:LOGIN',
  API.auth.loginUser,
);

export const loginAfterRedirect = getAsyncThunk(
  'AUTH:LOGIN',
  API.auth.loginUserAfterRedirect,
);

export const RE_LOGIN = 'AUTH:RE_LOGIN';

export const reLogin = () => ({ type: RE_LOGIN });

export const logout = getAsyncThunk(
  'AUTH:LOGOUT',
  API.auth.logoutUser,
);
